import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-route-layout',
  templateUrl: './route-layout.component.html',
  styleUrls: ['./route-layout.component.scss']
})
export class RouteLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
